

<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<!-- <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <div class="d-flex align-items-center">
                <h1 class="page-heading"><svg width="34" height="28" viewBox="0 0 34 28" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_390_1260)">
                            <path
                                d="M19.101 12.5953C18.4572 13.0232 17.7094 13.2494 16.9384 13.2494C16.1674 13.2494 15.4196 13.0232 14.7758 12.5953L4.1723 5.54654C4.11347 5.50742 4.05614 5.46665 4 5.42473V16.9749C4 18.2991 5.07778 19.3501 6.38213 19.3501H27.4946C28.8227 19.3501 29.8767 18.2755 29.8767 16.9749V5.42468C29.8204 5.4667 29.763 5.50758 29.704 5.54672L19.101 12.5953Z"
                                fill="#265D91" />
                            <path
                                d="M5.01334 4.28863L15.6169 11.3374C16.0183 11.6043 16.4783 11.7377 16.9383 11.7377C17.3984 11.7377 17.8585 11.6042 18.2598 11.3374L28.8634 4.28863C29.4979 3.86707 29.8767 3.16157 29.8767 2.4001C29.8767 1.09081 28.8085 0.0256958 27.4954 0.0256958H6.38132C5.06828 0.0257471 4 1.09086 4 2.40136C4 3.16157 4.37886 3.86707 5.01334 4.28863Z"
                                fill="#265D91" />
                        </g>
                        <defs>
                            <filter id="filter0_d_390_1260" x="0" y="0.0256958" width="33.877" height="27.3244"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="4" />
                                <feGaussianBlur stdDeviation="2" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_390_1260" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_390_1260"
                                    result="shape" />
                            </filter>
                        </defs>
                    </svg>

                    Messages
                </h1>
            </div>
            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <li class="breadcrumb-item text-muted">
                    <a  class="text-muted"  routerLink="/">Accueil</a>
                </li>
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li class="breadcrumb-item text-muted">Messages</li>
            </ul>
        </div>
    </div>
</div> -->









<!-- <div id="kt_app_content" class="app-content flex-column-fluid pb-0">

    <div id="kt_app_content_container" class="chat-content app-container container-fluid">

        <div class="d-flex flex-column flex-lg-row bg-chat" [ngClass]="{'align-items-center':currentConversationUserId === null}">

            <div class="flex-column left-content flex-lg-row-auto w-100 w-lg-300px w-xl-400px mb-10 mb-lg-0 mt-10">

                
                <div class="card left-side card-flush">
                    <ul class="px-6 pt-3 breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-2">
                        <li class="breadcrumb-item text-muted">
                            <a [routerLink]="['/wegestu/profil-candidat']" class="text-muted"
                                routerLinkActive="router-link-active">Accueil</a>
                        </li>
                        <li class="breadcrumb-item">
                            <span class="bullet bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <li class="breadcrumb-item text-muted">Messages</li>
                    </ul>
                    <div class="card-header pt-7" id="kt_chat_contacts_header">
                        <ul class="nav nav-tabs nav-line-tabs  fs-6">
                            <li class="nav-item">
                                <a class="nav-link active" data-bs-toggle="tab" href="#Messages" (contextmenu)="onRightClick($event)">Messages</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-bs-toggle="tab" href="#Utilisateurs" (contextmenu)="onRightClick($event)">Utilisateurs</a>
                            </li>
                        </ul>
                    </div>


                    <div class="card-body pt-5" id="kt_chat_contacts_body">

                        <div class="me-n5 pe-5  h-lg-auto ">
                            <div class="tab-content" id="myTabContent">
                                <div class="tab-pane fade  active show" id="Messages" role="tabpanel">

                                    <form class="w-100 position-relative  mb-5" autocomplete="off">

                                        <i
                                            class="ki-duotone ki-magnifier fs-3 text-gray-500 position-absolute top-50 ms-5 translate-middle-y">
                                            <span class="path1"></span>
                                            <span class="path2"></span>
                                        </i>

                                        <input 
                                            type="text" 
                                            class="form-control form-control-solid px-13 input-search" 
                                            name="search"
                                            placeholder="Rechercher dans les messages"
                                            (input)="onSearchInputMessage($event)" 
                                        />

                                    </form>
  
                                    <div class="scroll-y me-n5 pe-5  h-lg-auto chat_contacts" 
                                    *ngIf="listMessages?.length > 0; else noMessages"
                                    >

                                        <div class="list_users py-4" *ngFor="let conversation of listMessages" [ngClass]="{ 'new-message': conversation.new }">

                                            <div class="d-flex flex-stack startConvertion"
                                                (click)="userSelected(conversation?.user)">
                                                <div class="d-flex align-items-center">

                                                    <div class="symbol symbol-45px symbol-circle">
                                                        <img *ngIf="conversation?.user?.image_url; else noImageSender"
                                                                src="{{ getUserImage(conversation?.user) }}" alt="" 
                                                        />
                                                        <ng-template #noImageSender>
                                                          <span
                                                            class="symbol-label bg-light-danger text-danger fs-6 fw-bolder">
                                                            {{conversation?.user?.first_name?.charAt(0) | uppercase}} {{conversation?.user?.last_name?.charAt(0) | uppercase}}
                                                          </span>
                                                        </ng-template>
                                                        
                                                    </div>

                                                    <div class="ms-5">
                                                        <a
                                                            class="list-name  mb-2">{{conversation?.user?.first_name}} {{conversation?.user?.last_name}}
                                                            <ng-container *ngIf="conversation?.user?.company_name"> 
                                                                ({{ conversation?.user?.company_name }})
                                                            </ng-container>
                                                        </a>
                                                        <div class="list-mail">{{conversation?.chats[0]?.message}}</div>
                                                    </div>
                                                </div>
                                                <div class="role-user" >
                                                    <p style="margin: 2px;">{{conversation?.user?.Role ?
                                                        conversation?.user?.Role : '---'}}</p>
                                                </div>

                                            </div>

                                        </div>
                                        <mat-paginator
                                            [length]="totalPagesMessage"
                                            [pageSize]="pageSizeMessage"
                                            [showFirstLastButtons]="true"
                                            [pageSizeOptions]="pageSizeOptions"
                                            [pageIndex]="pageIndexMessage"
                                            (page)="onPageChange($event, 'M')"
                                            aria-label="Select page">
                                        </mat-paginator>
                                    </div>
                                    <ng-template #noMessages>
                                        <div class="alert alert-warning text-center mt-5" role="alert">
                                            <ng-container *ngIf="(searchMessageText?.length ?? 0) > 0; else noSearchMessage">
                                                <img src="/assets/media/logos/search-icon.png" alt="" class="mb-5" width="50px">
                                                <span class="empty-list">
                                                    Aucun résultat pour "{{searchMessageText}}" !
                                                </span>
                                            </ng-container>
                                            <ng-template #noSearchMessage>
                                            <span class="empty-list">
                                                Boîte de messagerie vide !
                                            </span>
                                            </ng-template>

                                        </div>
                                    </ng-template>
                                </div>
                                <div class="tab-pane fade" id="Utilisateurs" role="tabpanel">

                                    <form class="w-100 position-relative  mb-5" autocomplete="off">

                                        <i
                                            class="ki-duotone ki-magnifier fs-3 text-gray-500 position-absolute top-50 ms-5 translate-middle-y">
                                            <span class="path1"></span>
                                            <span class="path2"></span>
                                        </i>

                                        <input 
                                            type="text" 
                                            class="form-control form-control-solid px-13 input-search" 
                                            name="search"
                                            placeholder="Rechercher dans les utilisateurs"
                                            (input)="onSearchInputUser($event)" 
                                            [(ngModel)]="searchUserText"
                                        />

                                    </form>

                                    <div class="scroll-y me-n5 pe-5  h-lg-auto chat_contacts">
                                        <div *ngIf="dataEmployeeWithCompany?.length > 0; else noUsers">
                                            <div class="list_users py-4" *ngFor="let user of dataEmployeeWithCompany">

                                                <div class="d-flex flex-stack startConvertion"
                                                    (click)="userSelected(user, true)">
                                                    <div class="d-flex align-items-center">

                                                        <div class="symbol symbol-45px symbol-circle">
                                                            <img *ngIf="user?.image_url || user?.employee?.user?.image_url; else noImageUser"
                                                                src="{{ getListUserImage(user) }}" alt="" 
                                                            />
                                                            <ng-template #noImageUser>
                                                                <span class="symbol-label bg-light-danger text-danger fs-6 fw-bolder">
                                                                    {{user?.first_name?.charAt(0) | uppercase}} {{user?.last_name?.charAt(0) | uppercase}}
                                                                </span>
                                                            </ng-template>
                                                                
                                                        </div>

                                                        <div class="ms-5">
                                                            <a class="list-name  mb-2">{{user?.first_name}} {{user?.last_name}}
                                                                <ng-container *ngIf="getCompanyNameOfUser(user)">
                                                                    ({{ getCompanyNameOfUser(user) }})
                                                                </ng-container>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div class="role-user">
                                                        <p style="margin: 2px;">{{user?.Role ? user?.Role:'---'}}</p>
                                                    </div>

                                                </div>

                                            </div>
                                            <div>
                                        <mat-paginator
                                            [length]="totalPagesUser"
                                            [pageSize]="pageSizeUser"
                                            [showFirstLastButtons]="true"
                                            [pageSizeOptions]="pageSizeOptions"
                                            [pageIndex]="pageIndexUser"
                                            (page)="onPageChange($event, 'U')"
                                            aria-label="Select page">
                                        </mat-paginator>
                                       </div>
                                        </div>
                                    </div>

                                    <ng-template #noUsers>
                                        <div class="alert alert-warning text-center mt-5" role="alert">
                                        <img src="/assets/media/logos/search-icon.png" alt="" class="mb-5" width="50px">
                                        <span class="empty-list">
                                            Aucun résultat pour "{{searchUserText}}" !
                                        </span>
                                    </div>
                                    </ng-template>
                                </div>

                            </div>
                        </div>

                    </div>

                </div>

            </div>

            <div class="w-100 content-message">
        
                <div class="alert right-side d-flex flex-column justify-content-center align-items-center alert-warning mt-5" role="alert"
                    *ngIf="currentConversationUserId === null || !selectedUser">
                    <img src="/assets/media/img/empty-message.svg" alt="empty-chat-conversation" class="img-chat" >
                    <span class="empty-list">
                        Démarrer une conversation
                    </span>
                </div>
                <div class="card chat-messag mt-10" id="kt_chat_messenger" *ngIf="currentConversationUserId !== null && selectedUser">
    

                    <div class="card-header" id="kt_chat_messenger_header">
     
                        <div class="card-title">
                       



                            <div class="d-flex flex-stack py-2">
                          
                                <div class="d-flex align-items-center">
                           
                                    <div class="symbol symbol-45px symbol-circle">
                                        <img *ngIf="selectedUser?.image_url; else noImage"
                                            src="{{ getUserImage(selectedUser) }}" alt="" 
                                        >
                                        <ng-template #noImage>
                                            <div class="symbol symbol-45px symbol-circle">
                                                <span class="symbol-label bg-light-danger text-danger fs-6 fw-bolder">
                                                    {{selectedUser?.first_name?.charAt(0) | uppercase}} {{selectedUser?.last_name?.charAt(0) | uppercase}} 
                                                </span>
                                            </div>
                                        </ng-template>
                                    </div>
                                    
                                    <div class="ms-5">
                                        <a class="fs-5 fw-bold text-gray-900 text-hover-primary mb-2">
                                            {{ selectedUser?.first_name }} {{ selectedUser?.last_name }}
                                            <ng-container *ngIf="selectedUser?.company_name"> 
                                                ({{ selectedUser?.company_name }})
                                            </ng-container>
                                        </a>
                                    </div>
                                   
                                </div>
                               
                            </div>
                        </div>
                    
                        <div class="delete_icon">
                            <a class="btn-trash" (click)="openDeleteQuestionAlert(currentConversationUserId)">
                                <i class="fa fa-trash delete_btn" aria-hidden="true"></i></a>
                        </div>
                    </div>
                   
                    <div class="card-body height-msg" id="kt_chat_messenger_body">
                       
                        <div class="me-n5 pe-5 " *ngFor="let message of messages">
                           
                            <div class="d-flex flex-column align-items-end"
                                        *ngIf="currentConversationUserId !== null && message?.emitter?.uuid === currentConversationUserId ">
                                     
                                        <div class="d-flex align-items-center mb-2">
                                         
                                            <div class="me-3">
                                                <span class="time-sent mb-1">{{ message?.elapsedTime }}</span>


                                                <a  class="send-name ms-1">{{ message?.emitter?.first_name}} {{ message?.emitter?.last_name}}</a>
                                            </div>
                                       
                                            <div class="symbol symbol-35px symbol-circle">
                                                <img *ngIf="message?.emi_image_url; else noImageEmitter"
                                                    src="{{ getSenderImage(message) }}"
                                                    alt="" 
                                                />
                                                <ng-template #noImageEmitter>
                                                    <div class="symbol symbol-45px symbol-circle">
                                                        <span class="symbol-label bg-light-danger text-danger fs-6 fw-bolder">
                                                            {{message?.emitter?.first_name?.charAt(0) | uppercase}} {{message?.emitter?.last_name?.charAt(0) | uppercase }}
                                                        </span>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        
                                        </div>
                                      
                                        <div class="p-5 rounded bg-light-primary text-dark fw-semibold mw-lg-400px text-end"
                                            data-kt-element="message-text">{{message?.message}}</div>
                                        
                                    </div>
                           
                          
                            <div class="d-flex justify-content-start mb-5">
                               
                                <div class="d-flex flex-column align-items-start"
                                    *ngIf="currentConversationUserId !== null && message?.emitter?.uuid === currentUser?.uuid">
                                  
                                    <div class="d-flex align-items-center mb-2">
                                      
                                        <div class="symbol symbol-35px symbol-circle">
                                            <img *ngIf="message?.emi_image_url; else noImage"
                                                src="{{ getSenderImage(message) }}"
                                                alt="" 
                                            />

                                            <ng-template #noImage>
                                                <div class="symbol symbol-45px symbol-circle">
                                                    <span class="symbol-label bg-light-danger text-danger fs-6 fw-bolder">
                                                        {{message?.emitter?.first_name?.charAt(0) | uppercase}} {{message?.emitter?.last_name?.charAt(0) | uppercase }}
                                                    </span>
                                                </div>
                                            </ng-template>
                                        </div>
                                   
                                        <div class="ms-3">
                                            <a  class="send-name  me-1">{{message?.emitter?.first_name}} {{message?.emitter?.last_name}}</a>
                                            <span class="time-sent  mb-1">{{message?.elapsedTime}}</span>
                                        </div>
                                      
                                    </div>
                                    
                                    <div class="p-5 rounded bg-light-info text-dark fw-semibold mw-lg-400px text-start"
                                        data-kt-element="message-text">{{message?.message}}</div>
                                  
                                </div>
                              
                            </div>
                       
                        </div>
                        
                    </div>
                   
                    <div class="card-footer footer-form pt-4" id="kt_chat_messenger_footer">
                    
                        <div class="send_msg">
                            <textarea
                                class="form-control form-control-flush mb-3 auto-resize-textarea"
                                [(ngModel)]="newMessage"
                                placeholder="Entrez votre message"
                                rows="1"
                                (input)="autoResize($event)"
                            ></textarea>
                           
                            <div class="d-flex flex-stack">
                               
                                <div class="d-flex align-items-center me-2">

                                </div>
                              
                                <button class="btn-submit-chat"
                                    (click)="sendMessage()"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-send-horizontal"><path d="M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z"/><path d="M6 12h16"/></svg></button>
                              
                            </div>
                        </div>
                     
                    </div>
                  
                </div>
             
            </div>
        
        </div>
    
    </div>
  
</div> -->


<div id="kt_app_content" class="app-content flex-column-fluid pb-0">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="chat-content app-container container-fluid">
        <!--begin::Layout-->
        <div class="d-flex flex-column flex-lg-row bg-chat" [ngClass]="{'align-items-center':currentConversationUserId === null}">
            <!--begin::Sidebar-->
            <div class="flex-column left-content flex-lg-row-auto w-100 w-lg-300px w-xl-400px mb-10 mb-lg-0 mt-5">
                <!--begin::Contacts-->
                
                <div class="card left-side card-flush">
                    <ul class="px-6 pt-3 breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-2">
                        <li class="breadcrumb-item text-muted">
                            <a [routerLink]="['/wegestu/profil-candidat']" class="text-muted"
                                routerLinkActive="router-link-active">Accueil</a>
                        </li>
                        <li class="breadcrumb-item">
                            <span class="bullet bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <li class="breadcrumb-item text-muted">Messages</li>
                    </ul>
                    <div class="card-header pt-7" id="kt_chat_contacts_header">
                        <ul class="nav nav-tabs nav-line-tabs  fs-6">
                            <li class="nav-item">
                                <a class="nav-link active" data-bs-toggle="tab" href="#Messages" (contextmenu)="onRightClick($event)">Messages</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-bs-toggle="tab" href="#Utilisateurs" (contextmenu)="onRightClick($event)">Utilisateurs</a>
                            </li>
                        </ul>
                    </div>

                    <!--begin::Card body-->
                    <div class="card-body pt-5" id="kt_chat_contacts_body">
                        <!--begin::List-->
                        <div class="me-n5 pe-5  h-lg-auto ">
                            <div class="tab-content" id="myTabContent">
                                <div class="tab-pane fade  active show" id="Messages" role="tabpanel">
                                    <!--begin::Form-->
                                    <form class="w-100 position-relative  mb-5" autocomplete="off">
                                        <!--begin::Icon-->
                                        <i
                                            class="ki-duotone ki-magnifier fs-3 text-gray-500 position-absolute top-50 ms-5 translate-middle-y">
                                            <span class="path1"></span>
                                            <span class="path2"></span>
                                        </i>
                                        <input 
                                            type="text" 
                                            class="form-control form-control-solid px-13 input-search" 
                                            name="search"
                                            placeholder="Rechercher dans les messages"
                                            (input)="onSearchInputMessage($event)" 
                                        />
                                    </form>
                                    <div class="scroll-y me-n5 pe-5  h-lg-auto chat_contacts" 
                                    *ngIf="listMessages?.length > 0; else noMessages"
                                    >

                                        <div class="list_users py-4" *ngFor="let conversation of listMessages" [ngClass]="{ 'new-message': conversation.new }">
                                            <div class="d-flex flex-stack startConvertion"
                                                (click)="userSelected(conversation?.user)">
                                                <div class="d-flex align-items-center">
                                                    <div class="symbol symbol-45px symbol-circle">
                                                        <img *ngIf="conversation?.user?.image_url; else noImageSender"
                                                                src="{{ getUserImage(conversation?.user) }}" alt="" 
                                                        />
                                                        <ng-template #noImageSender>
                                                          <span
                                                            class="symbol-label bg-light-danger text-danger fs-6 fw-bolder">
                                                            {{conversation?.user?.first_name?.charAt(0) | uppercase}} {{conversation?.user?.last_name?.charAt(0) | uppercase}}
                                                          </span>
                                                        </ng-template>
                                                        
                                                    </div>
                                                    <div class="ms-5">
                                                        <a
                                                            class="list-name  mb-2">{{conversation?.user?.first_name}} {{conversation?.user?.last_name}}
                                                            <ng-container *ngIf="conversation?.user?.company_name"> 
                                                                ({{ conversation?.user?.company_name }})
                                                            </ng-container>
                                                        </a>
                                                        <div class="list-mail">{{conversation?.chats[0]?.message}}</div>
                                                    </div>
                                                </div>
                                                <div class="role-user" >
                                                    <p style="margin: 2px;">{{conversation?.user?.Role ?
                                                        conversation?.user?.Role : '---'}}</p>
                                                </div>
                                                <!--end::Details-->
                                            </div>
                                            <!--end::Details-->
                                        </div>
                                        <mat-paginator
                                            [length]="totalPagesMessage"
                                            [pageSize]="pageSizeMessage"
                                            [showFirstLastButtons]="true"
                                            [pageSizeOptions]="pageSizeOptions"
                                            [pageIndex]="pageIndexMessage"
                                            (page)="onPageChange($event, 'M')"
                                            aria-label="Select page">
                                        </mat-paginator>
                                    </div>
                                    <ng-template #noMessages>
                                        <div class="alert alert-warning text-center mt-5" role="alert">
                                            <ng-container *ngIf="(searchMessageText?.length ?? 0) > 0; else noSearchMessage">
                                                <img src="/assets/media/icons/search-icon.png" alt="" class="mb-5" width="50px">
                                                <span class="empty-list">
                                                    Aucun résultat pour "{{searchMessageText}}" !
                                                </span>
                                            </ng-container>
                                            <ng-template #noSearchMessage>
                                            <span class="empty-list">
                                                Boîte de messagerie vide !
                                            </span>
                                            </ng-template>

                                        </div>
                                    </ng-template>
                                </div>
                                <div class="tab-pane fade" id="Utilisateurs" role="tabpanel">
                                    <form class="w-100 position-relative  mb-5" autocomplete="off">
                                        <i
                                            class="ki-duotone ki-magnifier fs-3 text-gray-500 position-absolute top-50 ms-5 translate-middle-y">
                                            <span class="path1"></span>
                                            <span class="path2"></span>
                                        </i>
                                        <input 
                                            type="text" 
                                            class="form-control form-control-solid px-13 input-search" 
                                            name="search"
                                            placeholder="Rechercher dans les utilisateurs"
                                            (input)="onSearchInputUser($event)" 
                                            [(ngModel)]="searchUserText"
                                        />
                                    </form>
                                    <div class="scroll-y me-n5 pe-5  h-lg-auto chat_contacts">
                                        <div *ngIf="dataEmployeeWithCompany?.length > 0; else noUsers">
                                            <div class="list_users py-4" *ngFor="let user of dataEmployeeWithCompany">
                                                <div class="d-flex flex-stack startConvertion"
                                                    (click)="userSelected(user, true)">
                                                    <div class="d-flex align-items-center">
                                                        <div class="symbol symbol-45px symbol-circle">
                                                            <img *ngIf="user?.image_url || user?.employee?.user?.image_url; else noImageUser"
                                                                src="{{ getListUserImage(user) }}" alt="" 
                                                            />
                                                            <ng-template #noImageUser>
                                                                <span class="symbol-label bg-light-danger text-danger fs-6 fw-bolder">
                                                                    {{user?.first_name?.charAt(0) | uppercase}} {{user?.last_name?.charAt(0) | uppercase}}
                                                                </span>
                                                            </ng-template>
                                                                
                                                        </div>
                                                        <div class="ms-5">
                                                            <a class="list-name  mb-2">{{user?.first_name}} {{user?.last_name}}
                                                                <ng-container *ngIf="user?.company_name">
                                                                    ({{ user?.company_name }})
                                                                </ng-container>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div class="role-user">
                                                        <p style="margin: 2px;">{{user?.Role ? user?.Role:'---'}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                        <mat-paginator
                                            [length]="totalPagesUser"
                                            [pageSize]="pageSizeUser"
                                            [showFirstLastButtons]="true"
                                            [pageSizeOptions]="pageSizeOptions"
                                            [pageIndex]="pageIndexUser"
                                            (page)="onPageChange($event, 'U')"
                                            aria-label="Select page">
                                        </mat-paginator>
                                       </div>
                                        </div>
                                    </div>

                                    <ng-template #noUsers>
                                        <div class="alert alert-warning text-center mt-5" role="alert">
                                        <img src="/assets/media/icons/search-icon.png" alt="" class="mb-5" width="50px">
                                        <span class="empty-list">
                                            Aucun résultat pour "{{searchUserText}}" !
                                        </span>
                                    </div>
                                    </ng-template>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-100 content-message">
                <div class="alert right-side d-flex flex-column justify-content-center align-items-center alert-warning mt-5" role="alert"
                    *ngIf="currentConversationUserId === null || !selectedUser">
                    <img src="/assets/media/img/empty-message.svg" alt="empty-chat-conversation" class="img-chat" >
                    <span class="empty-list">
                        Démarrer une conversation
                    </span>
                </div>
                <div class="card chat-messag mt-5" id="kt_chat_messenger" *ngIf="currentConversationUserId !== null && selectedUser">
                    <div class="card-header" id="kt_chat_messenger_header">
                        <div class="card-title">
                            <div class="d-flex flex-stack py-2">
                                <div class="d-flex align-items-center">
                                    <div class="symbol symbol-45px symbol-circle">
                                        <img *ngIf="selectedUser?.image_url; else noImage"
                                            src="{{ getUserImage(selectedUser) }}" alt="" 
                                        >
                                        <ng-template #noImage>
                                            <div class="symbol symbol-45px symbol-circle">
                                                <span class="symbol-label bg-light-danger text-danger fs-6 fw-bolder">
                                                    {{selectedUser?.first_name?.charAt(0) | uppercase}} {{selectedUser?.last_name?.charAt(0) | uppercase}} 
                                                </span>
                                            </div>
                                        </ng-template>
                                    </div>
                                    <div class="ms-5">
                                        <a class="fs-5 fw-bold text-gray-900 text-hover-primary mb-2">
                                            {{ selectedUser?.first_name }} {{ selectedUser?.last_name }}
                                            <ng-container *ngIf="selectedUser?.company_name"> 
                                                ({{ selectedUser?.company_name }})
                                            </ng-container>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="delete_icon">
                            <a class="btn-trash" (click)="openDeleteQuestionAlert(currentConversationUserId)">
                                <i class="fa fa-trash delete_btn" aria-hidden="true"></i></a>
                        </div>
                    </div>
                    <div class="card-body height-msg" id="kt_chat_messenger_body">
                       <div class="message-content">
                            <div class="me-n5 pe-5 " [ngClass]="{'message-emetteur':message?.emitter?.uuid == currentConversationUserId, 'message-recepteur':message?.emitter?.uuid != currentConversationUserId}" *ngFor="let message of messages">
                           
                            <!-- <div class="d-flex flex-column align-items-end"
                                        *ngIf="currentConversationUserId !== null && message?.emitter?.uuid == currentConversationUserId "> -->
                                    
                                     <div class="d-flex flex-column test-emeteur">
                                        <div class="d-flex align-items-center mb-2">
                                            <div class="symbol symbol-35px symbol-circle">
                                                <img *ngIf="message?.emi_image_url; else noImageEmitter"
                                                    src="{{ getSenderImage(message) }}"
                                                    alt="" 
                                                />
                                                <ng-template #noImageEmitter>
                                                    <div class="symbol symbol-45px symbol-circle">
                                                        <span class="symbol-label bg-light-danger text-danger fs-6 fw-bolder">
                                                            {{message?.emitter?.first_name?.charAt(0) | uppercase}} {{message?.emitter?.last_name?.charAt(0) | uppercase }}
                                                        </span>
                                                    </div>
                                                </ng-template>
                                            </div>
                                            <div class="me-3">
                                                <a  class="send-name ms-1">{{ message?.emitter?.first_name}} {{ message?.emitter?.last_name}}</a>
                                                <span class="time-sent mb-1 ms-1">{{ message?.elapsedTime }}</span>
                                            </div>
                                        </div>
                                      
                                        <div class="p-5 rounded bg-light-primary text-dark fw-semibold mw-lg-400px text-end message-content"
                                            data-kt-element="message-text" [innerHTML]="formatMessage(message?.message)"></div>
                                        
                                    </div>
                            <div class="d-flex justify-content-end mb-5 test-recepteur">
                                <div class="d-flex flex-column align-items-end"
                                    *ngIf="currentConversationUserId !== null && message?.emitter?.uuid === currentUser?.uuid">
                                  
                                    <div class="d-flex align-items-center mb-2">
                                        <div class="ms-3">
                                            <span class="time-sent  mb-1 me-1">{{message?.elapsedTime}}</span>
                                            <a  class="send-name  me-1">{{message?.emitter?.first_name}} {{message?.emitter?.last_name}}</a>
                                        </div>
                                        <div class="symbol symbol-35px symbol-circle">
                                            <img *ngIf="message?.emi_image_url; else noImage"
                                                src="{{ getSenderImage(message) }}"
                                                alt="" 
                                            />

                                            <ng-template #noImage>
                                                <div class="symbol symbol-45px symbol-circle">
                                                    <span class="symbol-label bg-light-danger text-danger fs-6 fw-bolder">
                                                        {{message?.emitter?.first_name?.charAt(0) | uppercase}} {{message?.emitter?.last_name?.charAt(0) | uppercase }}
                                                    </span>
                                                </div>
                                            </ng-template>
                                        </div>
                                      
                                    </div>
                                    
                                    <div class="p-5 rounded bg-light-info text-dark fw-semibold mw-lg-400px text-start test-emetteur"
                                        data-kt-element="message-text">{{message?.message}}</div>
                                  
                                </div>
                              
                            </div>
                       
                        </div>
                       </div>
                       
                        
                    </div>
                        <!--end::Messages-->
                 
                    <!--end::Card body-->
                    <!--begin::Card footer-->
                    <div class="card-footer footer-form pt-4" id="kt_chat_messenger_footer">
                        <!--begin::Input-->
                        <div class="send_msg">
                            <textarea
                            class="form-control form-control-flush mb-3 auto-resize-textarea"
                            [(ngModel)]="newMessage"
                            placeholder="Entrez votre message"
                            rows="1"
                            (input)="autoResize($event)"
                        ></textarea>
                            <!--end::Input-->
                            <!--begin:Toolbar-->
                            <div class="d-flex flex-stack">
                                <!--begin::Actions-->
                                <div class="d-flex align-items-center me-2">

                                </div>
                                <!--end::Actions-->
                                <!--begin::Send-->
                                <button class="btn-submit-chat"
                                    (click)="sendMessage()"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-send-horizontal"><path d="M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z"/><path d="M6 12h16"/></svg></button>
                                <!--end::Send-->
                            </div>
                        </div>
                        <!--end::Toolbar-->
                    </div>
                    <!--end::Card footer-->
                </div>
                <!--end::Messenger-->
            </div>
            <!--end::Content-->
        </div>
        <!--end::Layout-->
    </div>
    <!--end::Content container-->
</div>
